import * as React from "react";
import CompanyHeading from "../../../components/theming/CompanyHeading";
import CustomTabs from "../../../components/theming/tabs/CustomTabs";
import { useSelector } from "react-redux";
import { AppState } from "../../../redux";
import { getTabsByRole } from "../../../components/core/profile-settings/tabsData";
import { useTranslation } from "react-i18next";
import { useTabPersistence } from "../../../hooks/useTabPersistence";

/**
 * Wrapper page for the profile settings.
 * @returns JSX.Element
 */
export const ProfileSettingsWrapperPage: React.FC = () => {
  const { t } = useTranslation(["common", "snackbars"]);
  const userData = useSelector((state: AppState) => state.user.currentUser);
  // Translate the labels
  const translatedTabs = getTabsByRole(userData?.user_type).map((tab) => ({
    ...tab,
    label: t(tab.label, { ns: "common" }),
  }));
  const { activeTab, handleTabChange } = useTabPersistence({ defaultTab: 0 });

  return (
    <>
      <CompanyHeading>{t("settings", { ns: "common" })}</CompanyHeading>

      <CustomTabs
        tabs={translatedTabs}
        activeTab={activeTab}
        onTabChange={handleTabChange}
      />
    </>
  );
};
